import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
// import ButtonBasic from '@/components/form/ButtonBasic.vue';
// import ToggleComponent from '@/components/form/ToggleComponent.vue';
//   import { ref } from 'vue';

export default {
  name: 'IntroInterests',
  components: {
    // ButtonBasic,
    // ToggleComponent,
  },
  mounted: function mounted() {
    console.log('<<<<<<<<< IntroInterests mounted >>>>>>>>>');
    this.preloadAudio("audioRewardingIntro", "/assets/audio/RewardingIntro.mp3");
    this.preloadAudio("audioPleaseWait", "/assets/audio/PleaseWait.mp3");
  },
  methods: {
    preloadAudio: function preloadAudio(name, audioPath) {
      if (!this.audioMap.get(name)) {
        var audio = new Audio(audioPath);
        this.audioMap.set(name, audio);
      }
    },
    backButton: function backButton() {
      this.$store.commit('stopIntroPage', 'Interests');
      this.$store.commit('startIntroPage', 'Personality');
    },
    playAudioByName: function playAudioByName(name) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var audio;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              audio = _this.audioMap.get(name);
              if (!audio) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", new Promise(function (resolve) {
                audio.onended = function () {
                  resolve();
                };
                if (audio.play) {
                  audio.play();
                }
              }));
            case 5:
              console.error("Audio file with name \"".concat(name, "\" not found."));
              return _context.abrupt("return", Promise.resolve());
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    nextPage: function nextPage() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var person;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$store.commit('updateHideBluetoothController', false);
              _context2.next = 3;
              return _this2.$store.dispatch("saveProfileToDB");
            case 3:
              if (_this2.$store.state.preventIntroExperience) {
                _context2.next = 41;
                break;
              }
              // this.$store.commit("updateShowMainEntryLoader", false);
              _this2.$store.commit('updateShowExperienceSelector', false);
              _this2.$store.commit('updateShowMainApplication', true);
              _this2.$store.commit('stopIntroPage', 'Interests');

              // 1
              _this2.preloadAudio("OpeningStatement1" + _this2.$store.state.avatar, "/assets/audio/intro/opening_remarks/intro1/".concat(_this2.$store.state.customerSelectedVoice, ".mp3") //   `/assets/audio/OpeningStatement1${this.$store.state.avatar}.mp3`,
              );
              _this2.preloadAudio("OpeningStatement2" + _this2.$store.state.avatar, "/assets/audio/intro/opening_remarks/intro2/".concat(_this2.$store.state.customerSelectedVoice, ".mp3") //   `/assets/audio/OpeningStatement2${this.$store.state.avatar}.mp3`,
              );
              _this2.preloadAudio("OpeningStatement3" + _this2.$store.state.avatar, "/assets/audio/intro/opening_remarks/intro3/".concat(_this2.$store.state.customerSelectedVoice, ".mp3") //   `/assets/audio/OpeningStatement3${this.$store.state.avatar}.mp3`,
              );

              // 4
              _this2.preloadAudio("OpeningStatement4" + _this2.$store.state.avatar, "/assets/audio/intro/opening_remarks/intro4/".concat(_this2.$store.state.customerSelectedVoice, ".mp3") //   `/assets/audio/OpeningStatement4${this.$store.state.avatar}.mp3`,
              );
              _this2.$store.commit("updateShowWalkthrough", false);
              _this2.$store.commit("updateProfileCompletedAlmost", true);
              // await this.playAudio('/assets/audio/PleaseWait.mp3');
              // await audioPleaseWait();
              _this2.showAITalking = true;
              _this2.aiSpeakingWords = "Please wait while your individualized companion is being initalized.";
              _this2.$store.commit("updateShowWalkthrough", false);
              _context2.next = 18;
              return _this2.playAudioByName("audioPleaseWait");
            case 18:
              _this2.$store.commit("updateShowWalkthrough", false);
              _this2.showAITalking = false;
              _this2.$store.commit("updateStartIntroFade", true);
              _context2.next = 23;
              return _this2.playAudioByName("audioRewardingIntro");
            case 23:
              _this2.$store.commit("updateStartBlur", true);
              _this2.$store.commit("updateOnDeviceAudioRecording", true);
              person = _this2.$store.state.avatar;
              _context2.next = 28;
              return _this2.playAudioByName("OpeningStatement1" + person);
            case 28:
              _context2.next = 30;
              return _this2.playAudioByName("OpeningStatement2" + person);
            case 30:
              _context2.next = 32;
              return _this2.playAudioByName("OpeningStatement3" + person);
            case 32:
              _context2.next = 34;
              return _this2.playAudioByName("OpeningStatement4" + person);
            case 34:
              _this2.$store.commit("updateShowMainEntryLoader", false);
              _this2.$store.commit("updateShowWalkthrough", true);
              _this2.$store.commit("updateProfileCompleted", true);
              // this.$store.commit('updateShowExperienceSelector', true);

              setTimeout(function () {
                _this2.$store.commit("updateShowQuickIntro", false);
                _this2.$store.commit("updateProfileCompletedAlmost", true);
                _this2.$store.commit("updateShowWalkthrough", true);
                _this2.$store.commit("updateNoIntroPointerEvents", true);
                _this2.$store.commit("updateProfileCompleted", true);
                //   this.$store.commit("updateStartIntroFade", false);
                _this2.$store.dispatch("crazyEggShowIntroSurveyQUICK");
                _this2.$store.commit("updateShowMainEntryLoader", false);

                // this.$store.dispatch("saveProfileToDB");
                setTimeout(function () {
                  // this.$store.dispatch("saveProfileToDB");
                }, 10000);
              }, 2000);

              // only do this if not on intro registration flow 
              if (!_this2.registrationFlow) {
                //save the settings we have set.
                _this2.$store.dispatch("saveProfileToDB");
              }
              _context2.next = 43;
              break;
            case 41:
              //second time around 
              _this2.$store.commit('updatePreventIntroExperience', false);
              // this.$store.dispatch("saveProfileToDB");
              _this2.$store.commit('stopIntroPage', 'Interests');
            case 43:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  },
  setup: function setup() {},
  data: function data() {
    return {
      registrationFlow: true,
      audioMap: new Map()
    };
  }
};